import * as React from 'react';
import { Route } from 'react-router';

import SettingsApp from 'bundles/account-settings/components/SettingsApp';
import UnsubscribeApp from 'bundles/account-settings/components/UnsubscribeApp';
import ZoomAccountLinkingRedirect from 'bundles/account-settings/components/ZoomAccountLinkingRedirect';
import loadOnRoute from 'bundles/common/components/loadOnRoute';

const UnsubscribePage = loadOnRoute(() => import('bundles/account-settings/components/UnsubscribePage'));
const NotFound = loadOnRoute(() => import('bundles/phoenix/components/NotFound'));

export default (
  <Route path="/">
    <Route component={SettingsApp} path="/account-settings(/ssr)" />

    <Route path="/account/unsubscribe" component={UnsubscribeApp}>
      <Route path=":token" getComponent={UnsubscribePage} />
    </Route>

    <Route path="/zoom-account-linking" component={ZoomAccountLinkingRedirect} />
    <Route path="/zoom-account-linking-dev" component={ZoomAccountLinkingRedirect} />
    <Route path="*" getComponent={NotFound} />
  </Route>
);
